<template>
  <div id="app">
    <!-- 顶部 dock 栏 -->
    <div class="dock">
      <div class="dockbox">
        <div
          :class="['dock-item', { active: activeSection === 'paul', 'red': activeSection === 'paul', 'sticky': activeSection === 'paul' }]"
          @click="scrollToSection('paul')">PAUL</div>
      </div>
      <div class="dockbox">
        <div
          :class="['dock-item', { active: activeSection === 'work', 'sticky': activeSection === 'work', 'gray': activeSection === 'paul', 'blue': activeSection === 'work' }]"
          @click="scrollToSection('work')">WORK</div>
      </div>
      <div class="dockbox">
        <div
          :class="['dock-item', { active: activeSection === 'studio' || activeSection === 'info', 'gray': activeSection === 'paul', 'blue': activeSection === 'studio' || activeSection === 'info', 'sticky': activeSection === 'studio' }]"
          @click="scrollToSection('studio')">SIG</div>
      </div>
      <div class="dockbox">
        <div
          :class="['dock-item', { active: activeSection === 'studio' || activeSection === 'info', 'gray': activeSection === 'paul', 'blue': activeSection === 'studio' || activeSection === 'info', 'sticky': activeSection === 'info' }]"
          @click="scrollToSection('info')">INFO</div>
      </div>



    </div>

    <!-- 内容区 -->
    <div id="content">
      <PaulSection v-if="activeSection === 'paul'" />
      <GridSection v-if="activeSection === 'work'" />
      <WorkSection v-if="activeSection === 'info'" />
      <StudioSection v-if="activeSection === 'studio'" />
      <InfoSection v-if="activeSection === 'info'" />

      <footer>
        <p>© 2025 Studio Paul. All rights reserved.</p>
        <p>All content on this website, including text, images, logos, graphics, and design, is the property of Studio
          Paul and is protected by copyright laws. Unauthorized reproduction, redistribution, or modification of any
          material from this website is prohibited.</p>
      </footer>
    </div>


  </div>
</template>

<script>
import PaulSection from './components/PaulSection.vue';
import WorkSection from './components/WorkSection.vue';
import StudioSection from './components/SigSection.vue';
import InfoSection from './components/InfoSection.vue';
import GridSection from './components/GridSection.vue'; // 引入 GridSection 组件

export default {
  name: 'App',
  components: {
    PaulSection,
    WorkSection,
    StudioSection,
    InfoSection,
    GridSection, // 注册 GridSection 组件
  },
  data() {
    return {
      activeSection: 'paul', // 默认显示 PAUL 部分
    };
  },
  methods: {
    scrollToSection(section) {
      this.activeSection = section;  // 更新当前激活的部分
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }

      // 更新 body 样式
      this.updateBodyStyle();
    },
    setActiveSectionOnScroll() {
      const sections = ['paul', 'work', 'studio', 'info'];
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
            this.updateBodyStyle(); // 更新 body 样式
          }
        });
      }, { threshold: 0.5 });

      sections.forEach(section => {
        const el = document.getElementById(section);
        if (el) {
          observer.observe(el);
        }
      });
    },
    updateBodyStyle() {
      if (this.activeSection === 'paul') {
        document.body.style.color = 'white';
        document.body.style.fontFamily = '"Times New Roman", Times, serif';
        document.body.style.display = 'block';
        document.body.style.margin = '0';
        document.body.style.backgroundColor = 'black';
        document.body.style.overflow = 'hidden'; // 不需要 overflow-x
      } else {
        document.body.style.color = 'white';
        document.body.style.fontFamily = '"Times New Roman", Times, serif';
        document.body.style.display = 'block';
        document.body.style.margin = '0';
        document.body.style.backgroundColor = 'black';
        document.body.style.overflow = ''; // 不需要 overflow-x
        document.body.style.overflowX = 'hidden'; // 其他部分设置 overflow-x: hidden
      }
    }
  },
  mounted() {
    this.setActiveSectionOnScroll();
  }
};
</script>

<style scoped>
#app {
  color: white;
  font-family: 'Times New Roman', Times, serif;
  display: block;
  margin: 0;
  /* overflow: hidden; */
  background-color: black;
}


.dock {
  display: grid;
  /* 使用 grid 布局 */
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  /* 水平居中每个 grid 项 */
  grid-template-rows: 1fr;
  /* 一行 */
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  /* 定义固定的高度 */
  user-select: none;

}

.dockbox {
  position: relative;
  top: 0vh;
  /* 确保滚动内容不被 Header 遮挡 */
  height: 500vh;

}

.dock-item {
  position: sticky;
  top: -4vw;
  /* 在父级容器顶部时固定 */
  font-weight: bold;
  font-size: 6vw;
  /* 字体大小 */
  color: rgb(255, 255, 255);
  cursor: pointer;
  transition: color 0.3s ease;
  z-index: 9999;
}

.dock-item:hover {
  color: rgb(78, 78, 78) !important;
}

/* .dock-item.active {
  font-weight: bold;
} */

.dock-item.red {
  color: rgb(102, 0, 0);
}

.dock-item.gray {
  color: rgb(37, 37, 37);
}

.dock-item.blue {
  color: blue;
}

/* 当标题为活跃部分时，设置粘性定位 */
.dock-item.sticky {
  position: sticky;
  top: 0;
  /* font-family: 'Microsoft YaHei', sans-serif; */
  /* 微软雅黑字体 */
  font-weight: bold;
  /* 加粗 */
  font-size: 6vw;
  /* 字体大小 */

  cursor: pointer;
  /* 鼠标悬停时显示为可点击 */
  transition: color 0.3s;
  /* 平滑的颜色过渡效果 */
}

/* 内容区域 */
#content {
  flex-grow: 1;
  position: relative;
  height: 100vh;
  /* 确保 App 占满整个视口 */
  background-color: rgb(0, 0, 0);
  /* 防止背景混乱 */
  /* overflow: hidden; */
}

/* footer 样式 */
footer {

  text-align: center;
  padding: 10px;
  font-size: 14px;
  z-index: 10;
  /* 确保 footer 在内容下面 */
  margin-top: 0;
  /* 不使用固定位置 */
}



section {
  background-color: #000000;
  z-index: 99;
  /* border-radius: 8px; */
}

section h2 {
  font-size: 2%;
  color: white;
}



/* 调整响应式样式 */
@media (max-width: 768px) {
  .dock {
    justify-content: space-around;
  }

  .dock-item {
    font-size: 24px;
    margin: 10px 5px;
  }
}
</style>
